var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "backTop"
  }, [_c("a-back-top", {
    attrs: {
      visibilityHeight: 320
    }
  }, [_c("svg-icon", {
    attrs: {
      icon: "backTop"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };